<template>
  <div>
    <CRow>
      <CCol col="12" xl="12">
        <CCard>
          <CCardHeader>
            <CButton color="success" @click="newPodcast" class="float-right">
              <CIcon name="cilPlus" />
              New Podcast
            </CButton>
            <h4>Podcast Shows</h4>
            <div class="text-muted">{{ total }} shows</div>
          </CCardHeader>
          <CCardBody>
            <CInput v-model="search" placeholder="Search podcast shows" class="mt-2 mb-4 clear-icon">
              <template #prepend-content><CIcon name="cil-magnifying-glass"/></template>
              <template v-if="search" #append-content
                ><CButton @click="clearSearch"><CIcon name="cil-x"/></CButton
              ></template>
            </CInput>
            <CDataTable
              hover
              striped
              :items="items"
              :fields="fields"
              clickable-rows
              @row-clicked="rowClicked"
              :pagination="false"
              :loading="isLoading"
            >
              <template #title="data">
                <td>
                  {{ data.item.title }}
                  <span v-if="data.item.status !== 'active'" class="badge rounded-pill" :class="data.item.status">{{ data.item.status }}</span>
                </td>
              </template>
              <template #image_url="data">
                <td>
                  <img :src="data.item.image_url" class="list_image" />
                </td>
              </template>
              <template #paywall_type="data">
                <td>
                  <CBadge class="ml-1" v-if="data.item.paywall_type" color="danger">
                    {{data.item.paywall_type}}
                  </CBadge>
                </td>
              </template>
              <template #edit="">
                <td>
                  <CIcon name="cil-arrow-right" />
                </td>
              </template>
              <template slot="no-items-view" v-if="isLoading">
                <span>Loading items</span>
              </template> 
            </CDataTable>
            <CPagination
              v-if="pages > 1"
              align="center"
              :active-page="activePage"
              v-on:update:activePage="pageChange"
              :pages="pages"
              :dots="false"
            />
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  name: 'Podcasts',
  data() {
    return {
      fields: [
        { key: 'id', sorter: true },
        { key: 'image_url', label: '', sorter: false },
        { key: 'title', _classes: 'font-weight-bold' },
        { key: 'publisher', label: 'Publisher' },
        { key: 'zdb_score', label: 'Score' },
        { key: 'episode_count', label: 'Episodes' },
        { key: 'paywall_type', label: 'Paywall' },
        { key: 'sec', label: 'Last Updated' },
        { key: 'edit', label: ' ', sorter: false },
      ],
      limit: 10,
      search: '',
      synced: [],
    }
  },
  watch: {
    activePage() {
      this.getData()
    },
    search: {
      handler() {
        // same if set in mounted
        if (this.search !== this.searched) {
          this.triggerSearch()
        }
      },
    },
  },
  mounted() {
    this.getData()
  },
  destroyed() {
    this.$store.dispatch('closeError')
  },
  computed: {
    activePage() {
      const { query } = this.$route
      return query && query.page ? Number(query.page) : 1
    },
    isLoading() {
      return this.$store.state.podcasts.isLoading
    },
    pages() {
      return Math.ceil(this.total / this.limit)
    },
    ...mapGetters({
      items: 'podcasts',
      paged: 'podcastsPaged',
      searched: 'podcastsSearched',
      total: 'podcastsTotal',
    }),
  },
  methods: {
    rowClicked(item) {
      this.$router.push({ path: `podcasts/${item.id}` })
    },

    newPodcast() {
      this.$router.push({ path: 'podcasts/0' })
    },

    pageChange(val) {
      this.$router.push({ query: { page: val } })
    },

    getData(triggerSearch = false) {
      this.$store.dispatch('getPodcasts', {
        $api: this.$api,
        search: this.search,
        limit: this.limit,
        is_own: false,
        page: triggerSearch ? 1 : this.activePage,
      })
    },

    triggerSearch: _.debounce(function() {
      this.getData(true)
    }, 500),

    clearSearch() {
      this.search = ''
    },
  },
}
</script>

<style>
.list_image {
  width: 36px;
  height: 36px;
}
.clear-icon .btn {
  height: 24px;
  padding: 0;
  margin: -4px;
}
.clear-icon .input-group-append > .input-group-text {
  background-color: white;
}
.duplicate {
  background-color: orange;
}
.blacklisted {
  background-color: red;
  color:  white;
}
</style>
